import { render, staticRenderFns } from "./ServicePlaceEditForm.vue?vue&type=template&id=251e5b8e&scoped=true&"
import script from "./ServicePlaceEditForm.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicePlaceEditForm.vue?vue&type=style&index=0&id=251e5b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251e5b8e",
  null
  
)

export default component.exports